import { Button, Card, CardContent, CardHeader, Checkbox, Chip, Divider, Drawer, Fade, FormControl, Grid, IconButton, InputBase, InputLabel, List, ListItem, ListItemButton, ListItemIcon, ListItemText, MenuItem, Paper, Popper, Select, Stack, TextField, Typography } from "@mui/material";
import { IShareFileShareComponentProps } from "./sharedFilesModel";
import { useEffect, useState } from "react";
import FacilitatorService from "../../facilitator/facilitatorService";
import { toast } from "react-toastify";
import { IAPIResponse, IHTTPResponse } from "../../common/models/httpModels";
import { ISchoolModel, ISchoolSummaryModel } from "../../facilitator/models/ISchoolModel";
import InfoIcon from '@mui/icons-material/Info';
import SearchIcon from '@mui/icons-material/Search';
import CancelIcon from '@mui/icons-material/Cancel';
import ClearIcon from '@mui/icons-material/Clear';
import { Padding } from "@mui/icons-material";
import PopupState, { bindToggle, bindPopper } from 'material-ui-popup-state';
import SendIcon from '@mui/icons-material/Send';
import {
    usePopupState,
    bindTrigger,
    bindPopover,
} from 'material-ui-popup-state/hooks'
import { LoadingButton } from "@mui/lab";
import { FoundationProgramConstants } from "../../common/data/foundationPrograms";
import { OlympiadExamConstants } from "../../common/data/olympiadExams";

export const EAbhyasFileShareComponent = (props: IShareFileShareComponentProps) => {
    const { handleClose, updateSchoolFileShare, schoolFile, isShareInProgress } = props;
    const [schoolList, setSchoolList] = useState<ISchoolSummaryModel[]>([]);
    const [selectedSchools, setSelectedSchools] = useState<ISchoolSummaryModel[]>([]);
    const [filteredSchools, setFilteredSchools] = useState<ISchoolSummaryModel[]>([]);
    const [searchText, setSearchText] = useState<string>("");
    const [isAllSchoolsSelected, setAllSchoolsSelected] = useState<boolean>(false);
    const [filterFoundationProgram, setFilterFoundationProgram] = useState<string>('');
    const [filterOlympiadExam, setFilterOlympiadExam] = useState<string>('');
    const [filterState, setFilterState] = useState('');
    const clearFilters = () => {
        setFilterFoundationProgram('');
        setFilterOlympiadExam('');
        setFilterState('');
        setFilteredSchools(schoolList);
    }
    const handleFProgramChange = (event: any) => {
        setFilterFoundationProgram(event.target.value);
    };

    const handleOExamChange = (event: any) => {
        setFilterOlympiadExam(event.target.value);
    };

    const handleStateFilterChange = (event: any) => {
        setFilterState(event.target.value);
    }

    useEffect(() => {
        let tempFilteredSchools = schoolList;
        if (filterFoundationProgram !== '') {
            tempFilteredSchools = tempFilteredSchools.filter(s => s.foundationPrograms.some(fp => fp.programId.toString() === filterFoundationProgram));
        }
        if (filterOlympiadExam !== '') {
            tempFilteredSchools = tempFilteredSchools.filter(s => s.olympiadExams.some(fp => fp.examId.toString() === filterOlympiadExam));
        }
        if (filterState !== '') {
            tempFilteredSchools = tempFilteredSchools.filter(s => s.state === filterState);
        }
        setFilteredSchools(tempFilteredSchools);
    }, [filterFoundationProgram, filterOlympiadExam, filterState, schoolList]);


    const popupState = usePopupState({
        variant: 'popover',
        popupId: 'demoPopover',
    })
    const loadSchools = () => {
        FacilitatorService.getSchoolsSummary().then((res: IHTTPResponse<IAPIResponse<ISchoolSummaryModel>>) => {
            if (res?.data?.errors?.length > 0) {
                let errorMessage = "";
                res?.data?.errors.forEach((i) => {
                    if (errorMessage !== "") {
                        errorMessage += "\n";
                    }
                    errorMessage += i.field + " : " + i.message;
                });
                toast.error(errorMessage);
                setSchoolList([]);
                setFilteredSchools([]);
                setAllSchoolsSelected(false);
            }
            if (res.data !== null || res.data !== undefined) {
                setSchoolList(res.data.list);
                setFilteredSchools(res.data.list);
                const preSelectedSchools = res.data.list.filter(i => schoolFile.schoolSharings.some(f => f.schoolUserId === i.userId));
                setSelectedSchools(preSelectedSchools);
                setAllSchoolsSelected(preSelectedSchools.length === res.data.list.length);

            }
        }).catch(() => {
            toast.error('error in loading schools data');
        }).finally(() => {

        })
    }
    const handleToggleSchool = (selectedSchool: ISchoolSummaryModel) => {
        if (isSchoolSeelcted(selectedSchool)) {
            setSelectedSchools(selectedSchools.filter(i => i.userId !== selectedSchool.userId));
        }
        else {
            setSelectedSchools([...selectedSchools, selectedSchool]);
        }

        setAllSchoolsSelected(selectedSchools.length + 1 === filteredSchools.length);

    }
    const handleSelectAllSchools = () => {
        if (isAllSchoolsSelected) {
            setSelectedSchools([]);
            setAllSchoolsSelected(false);
        }
        else {
            setSelectedSchools(filteredSchools);
            setAllSchoolsSelected(true);
        }
    }
    const isSchoolSeelcted = (school: ISchoolSummaryModel): boolean => {
        return selectedSchools.find(i => i.userId === school.userId) !== undefined;
    }

    useEffect(() => {
        loadSchools();

    }, []);
    const handleSearchTextChange = (e: React.ChangeEvent<HTMLInputElement | HTMLTextAreaElement>) => {
        const value = e.target.value;
        setSearchText(value);
        if (value.length > 0) {
            setFilteredSchools(schoolList.filter(i =>
                (i.schoolName.toLowerCase().includes(value.toLowerCase()) || i.userName.toLowerCase().includes(value.toLowerCase()))
            ));
        } else {
            setFilteredSchools(schoolList);
        }
    }
    const filterSchools = () => {
        if (searchText.length > 0) {
            setFilteredSchools(schoolList.filter(i =>
                (i.schoolName.toLowerCase().includes(searchText.toLowerCase()) || i.userName.toLowerCase().includes(searchText.toLowerCase()))
            ));
        }
        else {
            setFilteredSchools(schoolList);
        }
    }
    const handleShareClick = () => {
        updateSchoolFileShare(schoolFile, selectedSchools);
    }
    return (<Drawer
        anchor={'right'}
        open={true}
        onClose={handleClose}
    >
        <>
            <div style={{ position: "fixed", top: '0', zIndex: '9999', backgroundColor: '#fff' }} >

                <Grid container spacing={2} sx={{ padding: '16px' }}>
                    <Grid item xs={12} sx={{ paddingRight: '0' }}>
                        <Paper
                            variant="outlined"
                            component="form"
                            sx={{ p: '2px 4px', display: 'flex', alignItems: 'center', width: '100%' }}
                        >

                            <InputBase
                                sx={{ ml: 1, flex: 1 }}
                                placeholder="Search Schools"
                                inputProps={{ 'aria-label': 'search schools' }}
                                fullWidth
                                value={searchText}
                                onChange={handleSearchTextChange}
                            />
                            <IconButton type="button" sx={{ p: '10px' }} aria-label="search" onClick={() => filterSchools()}>
                                <SearchIcon />
                            </IconButton>
                            <Divider sx={{ height: 28, m: 0.5 }} orientation="vertical" />
                            <IconButton color="primary" sx={{ p: '10px' }} aria-label="directions" onClick={() => setFilteredSchools(schoolList)}>
                                <CancelIcon />
                            </IconButton>
                        </Paper>
                    </Grid>


                    <Grid item xs={8} sx={{ alignContent: "center" }}>
                        <Typography variant="caption" display="block" gutterBottom={true} align="center">

                            Total - {schoolList.length} | Filtered - {filteredSchools.length} | Selected - {selectedSchools.length}
                        </Typography>

                    </Grid>
                    <Grid item xs={4} sx={{ textAlign: 'right' }}>
                        <LoadingButton
                            onClick={handleShareClick}
                            endIcon={<SendIcon />}
                            loading={isShareInProgress}
                            loadingPosition="end"
                            variant="outlined"
                        >
                            <span>Share</span>
                        </LoadingButton>

                    </Grid>
                </Grid>






            </div>


            <div style={{ marginTop: '130px' }}>

                <div>
                    <FormControl sx={{ m: 1, minWidth: 180 }} size="small">
                        <InputLabel id="demo-simple-select-helper-label">Foundation Program</InputLabel>
                        <Select
                            labelId="demo-simple-select-helper-label"
                            id="demo-simple-select-helper"
                            value={filterFoundationProgram}
                            label="Foundation Program"
                            onChange={handleFProgramChange}
                        >
                            <MenuItem value="">
                                <em>All</em>
                            </MenuItem>
                            {FoundationProgramConstants.map(fp => (
                                <MenuItem key={fp.programId} value={fp.programId}>{fp.programName}</MenuItem>
                            ))}

                        </Select>

                    </FormControl>
                    <FormControl sx={{ m: 1, minWidth: 100 }} size="small">
                        <InputLabel id="demo-simple-select-helper-label">Olympiads</InputLabel>
                        <Select
                            value={filterOlympiadExam}
                            onChange={handleOExamChange}
                            label="Olympiad Programs"
                        >
                            <MenuItem value="">
                                <em>All</em>
                            </MenuItem>
                            {
                                OlympiadExamConstants.map(oe => (
                                    <MenuItem key={oe.examId} value={oe.examId}>{oe.examName}</MenuItem>
                                ))
                            }

                        </Select>

                    </FormControl>
                    <FormControl sx={{ m: 1, minWidth: 70 }} size="small">
                        <InputLabel id="demo-simple-select-helper-label">State</InputLabel>
                        <Select
                            value={filterState}
                            onChange={handleStateFilterChange}
                            label="State"
                        >
                            <MenuItem value="">
                                <em>All</em>
                            </MenuItem>
                            <MenuItem key={'AP'} value={'AP'}>{'AP'}</MenuItem>
                            <MenuItem key={'TG'} value={'TG'}>{'TG'}</MenuItem>


                        </Select>

                    </FormControl>
                    <FormControl sx={{ m: 1, minWidth: 40 }} size="small">
                        <IconButton onClick={clearFilters} color="error" >
                            <ClearIcon />
                        </IconButton >
                    </FormControl>
                </div>




                <List>

                    <ListItem disablePadding>
                        <ListItemButton dense onClick={() => handleSelectAllSchools()}>
                            <ListItemIcon>
                                <Checkbox
                                    edge="start"
                                    checked={isAllSchoolsSelected}
                                    tabIndex={-1}
                                    disableRipple
                                />
                            </ListItemIcon>
                            <ListItemText primary={'Select All'} />
                        </ListItemButton>
                    </ListItem>


                    {
                        filteredSchools.map((school, key) => (
                            <>
                                <ListItem
                                    key={key}
                                    secondaryAction={
                                        <>
                                            <IconButton edge="end" aria-label="comments" {...bindTrigger(popupState)}>
                                                <InfoIcon />
                                            </IconButton>

                                            <Popper {...bindPopper(popupState)} transition>
                                                {({ TransitionProps }) => (
                                                    <Fade {...TransitionProps} timeout={350}>
                                                        <Paper>
                                                            <Typography sx={{ p: 2 }}>The content of the Popper.</Typography>
                                                        </Paper>
                                                    </Fade>
                                                )}
                                            </Popper>
                                        </>
                                    }
                                    disablePadding
                                >
                                    <ListItemButton dense onClick={() => handleToggleSchool(school)}>
                                        <ListItemIcon>
                                            <Checkbox
                                                edge="start"
                                                checked={isSchoolSeelcted(school)}
                                                tabIndex={-1}
                                                disableRipple
                                                inputProps={{ 'aria-labelledby': school.userName }}
                                            />
                                        </ListItemIcon>
                                        <ListItemText id={school.userName} primary={school.userName + ' | ' + school.schoolName} />
                                    </ListItemButton>
                                </ListItem>

                            </>
                        ))
                    }
                </List>

            </div>
        </>






    </Drawer >
    );
}